import { IGeeProduct, IGeeProductAddToCart, IGeeProductDetail } from "../models/GoogleEnhancedEcommerce";

class GoogleEnhancedEcommerce {
    // Report View of product or variant to Google
    public PushViewToGoogle(
        Name: string,
        Id: string,
        Price: number,
        Category: string,
    ) {
        let Products: IGeeProductDetail[];
        Products = [
            {
                name: Name,
                id: Id,
                price: Price ? Price.toString() : "0",
                category: Category
            } as IGeeProductDetail
        ];

        // Create GEE View product object
        const geeObject = {
            event: "detail",
            ecommerce: {
                detail:
                    { products: Products }
            }
        };

        this.PushDataLayer(geeObject);
    }

    public PushPostalCodeToGoogle(postalCode: string) {
         // Create GEE postal code Object
         const geeObject = {
            event: "checkoutPostalCodeSelection",
            postalCode: { postalCode }
        };

         this.PushDataLayer(geeObject);
    }

    public PushProductsAddToCartToGoogle(products: IGeeProduct[], currencyCode: string, dimensionIdentifier: string, isShoppingList: boolean = false) {
        const addToCartProducts = products.map<IGeeProductAddToCart>(product => ({
                name: product.name,
                id: product.id,
                price: product.price ? product.price.toString() : "0",
                category: product.category,
                quantity: product.quantity,
                dimension1: dimensionIdentifier,
                metric1: this.getTotalItemPrice(product.price, product.quantity)
            })
        );

        // Create GEE AddToCart Object
        const geeObject = {
            event: isShoppingList ? "add_to_wishlist" : "addToCart",
            ecommerce: {
                currencyCode,
                add: {
                    products: addToCartProducts
                }
            }
        };

        this.PushDataLayer(geeObject);
    }

    // Report products that add to cart to Google
    public PushAddToCartToGoogle(
        name: string,
        id: string,
        price: number,
        category: string,
        quantity: number | undefined,
        dimensionIdentifier: string,
        currencyCode: string,
        isShoppingList: boolean,
    ) {

        let products: IGeeProduct[];
        products = [
            {
                name,
                id,
                price,
                category,
                quantity
            }
        ];

        this.PushProductsAddToCartToGoogle(products, currencyCode, dimensionIdentifier, isShoppingList);
    }

    private PushDataLayer(geeObject: any) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(geeObject);
    }

    private getTotalItemPrice(price: number | undefined, quantity: number | undefined) {
        if (Number(price) && Number(quantity)) {
            return (Number(price) * Number(quantity)).toString();
        }
        return "0";
    }
}

export default GoogleEnhancedEcommerce;
